import NavbarTP from "./ordini/NavbarTopORD";
import OrdiniUrgenti from "./ordini/OrdiniUrgenti";
import Rimessi from "./ordini/Rimessi";
import Anomalie from "./ordini/Anomalie";
import BarreFornitori from "./ordini/BarreFornitori";
import InfoOrdini from "./ordini/InfoOrdini";
import CardFix from "./ordini/CardFix";
import CrossDocking from "./ordini/CrossDocking";
import TortaOggi from "./ordini/TortaOggi";
import BarraImporto from "./ordini/BarraImporto";
import MappaPercorso from "./ordini/MappaPercorso";
import "../App.css";

function Home() {
  return (
    <div className="main-container">
      <NavbarTP />

      <div className="technoparts">
        <div className="card-container">
          <TortaOggi />
          <BarraImporto />
        </div>
        <BarreFornitori />
        <CardFix />

        <OrdiniUrgenti />
        <Rimessi />
        <Anomalie />
        <InfoOrdini />
        <CrossDocking />

        <MappaPercorso />
      </div>
    </div>
  );
}

export default Home;
